<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/association/detail/'+association?.id ">chevron_left</mat-icon>
            <h1 class="page-title">Edit Association </h1>
        </div>

        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/association'">Associations</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/association/detail/' + association.id">{{association.providerName}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Edit</span>
        </div>
    </div>

    <hr class="mb-5" />

    <form [formGroup]="form">
        <div class="row mt-5">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Association Name</mat-label>
                    <input type="text" matInput formControlName="associationName">
                </mat-form-field>
            </div>
        </div>

        <hr class="mb-5" />

        <h4 class="mb-5">Detail Association</h4>

        <div class="row">
            <div class="col-6">
                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="full-width w-100" appearance="outline">
                            <mat-label>Email</mat-label>
                            <input type="text" matInput formControlName="email">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="full-width w-100" appearance="outline">
                            <mat-label>Phone</mat-label>
                            <input type="text" matInput formControlName="phone">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="full-width w-100" appearance="outline">
                            <mat-label>Registered On</mat-label>
                            <input [readonly]="true" matInput formControlName="registeredOn" [matDatepicker]="picker" placeholder="Choose a date">
                            <mat-datepicker-toggle style="color: #fff" matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="full-width w-100" appearance="outline">
                            <mat-label>Website</mat-label>
                            <input type="text" matInput formControlName="website">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <mat-form-field class="full-width w-100" appearance="outline">
                            <mat-label>Address</mat-label>
                            <input type="text" matInput formControlName="address">
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <label class="text-color-black-normal-50 label-radio">Status</label>
                        <mat-radio-group formControlName="status" class="status-radio-group">
                            <mat-radio-button value="true">Active</mat-radio-button>
                            <mat-radio-button value="false">Inactive</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="row my-5">
            <div class="col-12 text-end">
                <button mat-raised-button (click)="editAssociation()" class="edit-button">Save</button>
            </div>
        </div>
    </form>
</div>
